import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import Carousel from '@nerdwallet/react-carousel';

import MeetNerdsTile from './company-meet-nerds-tile';

const MeetNerds = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile, id) => (
    <MeetNerdsTile {...tile} key={id} />
  ));

  return (
    <div
      className={classNames([
        'meet-nerds__container',
        classes('margin-top-0'),
        classes('margin-bottom-5'),
        classes('margin-horizontal-auto'),
      ])}
    >
      <Carousel
        id="meet-nerds"
        autoplay={false}
        allowLooping
        decorateNav={false}
        enableDotNavigation
        inactiveDotColor="#000000"
        activeDotColor="#008255"
        className={classNames([
          classes('margin-top-0'),
          classes('margin-horizontal-auto'),
        ])}
      >
        {renderedTiles}
      </Carousel>
    </div>
  );
};

MeetNerds.displayName = 'Meet Nerds';

MeetNerds.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(MeetNerds.propTypes)),
  className: PropTypes.string,
  id: PropTypes.number,
};

export default MeetNerds;
